var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8316 2.51292C22.6298 2.40054 24.4029 3.02489 25.7391 4.24862C26.9628 5.58474 27.5872 7.35791 27.4873 9.16853V20.8315C27.5997 22.6421 26.9628 24.4153 25.7516 25.7514C24.4154 26.9751 22.6298 27.5995 20.8316 27.4871H9.16859C7.35795 27.5995 5.58477 26.9751 4.24864 25.7514C3.02489 24.4153 2.40053 22.6421 2.51292 20.8315V9.16853C2.40053 7.35791 3.02489 5.58474 4.24864 4.24862C5.58477 3.02489 7.35795 2.40054 9.16859 2.51292H20.8316ZM13.7264 21.0562L22.1303 12.6275C22.892 11.8533 22.892 10.6045 22.1303 9.84283L20.5069 8.21951C19.7327 7.44532 18.484 7.44532 17.7098 8.21951L16.8732 9.06864C16.7483 9.19351 16.7483 9.40579 16.8732 9.53066C16.8732 9.53066 18.8586 11.5036 18.8961 11.5536C19.0335 11.7034 19.1209 11.9032 19.1209 12.128C19.1209 12.5775 18.7587 12.9521 18.2967 12.9521C18.0844 12.9521 17.8846 12.8647 17.7473 12.7274L15.6619 10.6545C15.562 10.5546 15.3872 10.5546 15.2873 10.6545L9.33092 16.6108C8.91884 17.0229 8.68159 17.5723 8.6691 18.1592L8.59418 21.1187C8.59418 21.281 8.64413 21.4308 8.75651 21.5432C8.8689 21.6556 9.01874 21.718 9.18107 21.718H12.1156C12.7149 21.718 13.2894 21.4808 13.7264 21.0562Z",
    fill: "#0098EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen_icon.342fb12f1ee6aed1668af3fbbe8f1315.svg";
export { ForwardRef as ReactComponent };